module.exports = ".status{\r\n    font-weight: bold;\r\n}"